<template>
  <f7-page name="vehicle">
    <bc-navbar></bc-navbar>
    <div class="page_maincontent layout_fullwidth_padding" v-if="isLoaded">
      <a @click="back()">
        <img src="/static/images/icons/black/back.png" alt="" class="back_image_button" title="" />
      </a>
      <div class="car-top">
        <h2 class="page_title margin_left_none" style="font-weight:bold">
          {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.modelName }}
          {{ vehicle.trim }}
        </h2>

        <section class="price-section">
          <span class="price">{{ price(vehicle.offeringPrice) }}</span>
          <template v-if="hasDealerFees">
            <div class="price-row">
              <span>Market</span> <span>{{ price(vehicle.price) }}</span>
            </div>
            <div class="price-row" v-for="item in vehicle.applicableDealerFees" :key="item.id">
              <span>{{ item.label }}</span> <span>{{ price(item.amount) }}</span>
            </div>
            <hr class="divider" />
            <div class="price-row summary-price">
              <span>Offering price</span> <span class="summary-price-value">{{ price(vehicle.offeringPrice) }}</span>
            </div>
          </template>
          <price-info />
        </section>

        <div class="car-top-image">
          <img :src="vehicle.photos[0]"
            onerror="this.src='https://vassstorage.blob.core.windows.net/salesraterprod/images/m_no_photo.png'" />
          <button @click="
            onFavorite({
              vehicleId: vehicle.id,
              isFavorite: !vehicle.isFavorite,
            })
            " class="like-btn">
            <span class="dbc-icon" :class="{
              'dbc-icon-heart': vehicle.isFavorite,
              'dbc-icon-heart-empty': !vehicle.isFavorite,
            }"></span>
          </button>
        </div>
      </div>
      <div class="car-description-container">
        <a class="button_full btgreen" href="#" @click="switchGallery()" v-if="vehicle.photos.length > 1">
          <span>View All Images</span>
        </a>
        <a class="button_full btn-blue-outlined" @click.prevent="checkAvailabilityLink">
          <span>Check Availablity</span>
        </a>
        <a v-if="vehicle.testDriveLink" class="button_full btn-blue-outlined" href="#"
          @click.prevent="openModal(vehicle.testDriveLink)">
          <span>Schedule Test Drive</span>
        </a>
        <a v-if="vehicle.calculePaymentsLink" class="button_full btn-blue-outlined" href="#"
          @click.prevent="openModal(vehicle.calculePaymentsLink)">
          <span>Calculate Payments</span>
        </a>
        <table>
          <tr>
            <th :style="borderStyle">Type</th>
            <th :style="borderStyle">VIN</th>
            <th :style="borderStyle">STOCK #</th>
          </tr>
          <tr>
            <td>{{ vehicle.saleClass }}</td>
            <td>{{ vehicle.vin }}</td>
            <td>{{ vehicle.stockNumber }}</td>
          </tr>
        </table>

        <div v-if="vehicle.description" class="car-desc-text">
          <span>{{
            vehicle.description.substr(0, minDescriptionLength)
          }}</span>
          <span v-if="showMoreDots">...</span>
          <span v-if="isShowMore && vehicle.description">{{
            vehicle.description.substr(minDescriptionLength, vehicle.description.length)
          }}</span>
          <a v-if="showMoreBtn" class="button_full button-white" href="#" @click="showMoreDesc()">
            <span v-if="!isShowMore">SHOW MORE</span>
            <span v-if="isShowMore">SHOW LESS</span>
          </a>
        </div>

        <div class="brochure-list" v-if="brochures.length > 0">
          <table class="text-left">
            <tr>
              <th :style="borderStyle">Download Brochure</th>
            </tr>
            <tr v-for="(broc, key) in brochures" :key="key">
              <td class="">
                <a style="display:block;" @click="openBrochure(broc)" :href="broc.fileUrl" target="_blank"
                  class="external">{{ broc.year }} {{ broc.make }} {{ broc.model }}
                  {{ broc.submodel }}
                </a>
              </td>
            </tr>
          </table>
        </div>
        <table class="text-left">
          <tr>
            <th :style="borderStyle">CATEGORY</th>
            <th :style="borderStyle">VALUE</th>
          </tr>
          <tr>
            <td>Model</td>
            <td>{{ vehicle.modelName }}</td>
          </tr>
          <tr>
            <td>Trim</td>
            <td>{{ vehicle.trim }}</td>
          </tr>
          <tr>
            <td>Year</td>
            <td>{{ vehicle.year }}</td>
          </tr>
          <tr>
            <td>Body</td>
            <td>{{ vehicle.bodyStyle }}</td>
          </tr>
          <tr>
            <td>Engine</td>
            <td>{{ vehicle.engine }}</td>
          </tr>
          <tr>
            <td>Transmission</td>
            <td>{{ vehicle.transmission }}</td>
          </tr>
          <tr>
            <td>Drive Train</td>
            <td>{{ vehicle.driveTrain }}</td>
          </tr>
          <tr>
            <td>Odometer</td>
            <td>{{ vehicle.odometer }}</td>
          </tr>
          <tr>
            <td>City</td>
            <td>{{ vehicle.fuelEconomy.city }}</td>
          </tr>
          <tr>
            <td>Highway</td>
            <td>{{ vehicle.fuelEconomy.highway }}</td>
          </tr>
        </table>

        <table class="text-left">
          <tr>
            <th :style="borderStyle">KEY FEATURES</th>
          </tr>
          <tr v-for="(option, key) in vehicle.dealerOptions" :key="key">
            <td class="">{{ option }}</td>
          </tr>
        </table>
      </div>
    </div>

    <!-- loader -->
    <div v-if="!isLoaded" class="loader-container" color="#f9f300">
      <loader :animation-duration="2500" :rhombus-size="25" color="#f9f300" />
    </div>
    <f7-popup ref="modal" class="widget-modal">
      <div class="widget-wrap">
        <iframe id="widget" :src="widgetUrl" frameborder="0"></iframe>
        <div v-if="widgetLoading" class="modal-loader">
          <loader :animation-duration="2500" :rhombus-size="25" color="#f9f300" />
        </div>
      </div>
    </f7-popup>
  </f7-page>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { LoopingRhombusesSpinner } from 'epic-spinners'
import priceHelper from '../../helpers/price.helper'
import { openSMSEditor } from '../../helpers/sms-editor'
import PriceInfo from '../../components/inventory/price-info.vue'

export default {
  components: {
    LoopingRhombusesSpinner,
    loader: LoopingRhombusesSpinner,
    'price-info': PriceInfo
  },
  created: async function () {
    await this.loadCurrentVehical(this.vehicleId)
    await this.loadBrochures({
      make: this.vehicle.make,
      model: this.vehicle.modelName,
      year: this.vehicle.year
    })
    this.isLoaded = true
  },
  computed: {
    ...mapState({
      vehicle: (state) => state.inventory.currentVehicale,
      brochures: (state) => state.brochure.brochures,
      customization: (state) => state.common.customization,
      salesPhone: (state) => state.common.phone,
      salesPersonFullName: (state) => state.common.salesPersonFullName,
      isSafari: (state) => state.standalone.isSafari,
      isChrome: (state) => state.standalone.isChrome
    }),
    ...mapGetters({
      userProfile: 'editUserProfile/getUserProfile'
    }),
    borderStyle: function () {
      var borderStyle = this.customization.borderOn
        ? 'solid 1px ' + this.customization.borderColor
        : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    },
    showMoreDots () {
      return !this.isShowMore && this.vehicle.description && this.vehicle.description.length > this.minDescriptionLength
    },
    showMoreBtn () {
      return this.vehicle.description && this.vehicle.description.length > this.minDescriptionLength
    },
    hasDealerFees () {
      return !!(this.vehicle.applicableDealerFees && this.vehicle.applicableDealerFees.length)
    }
  },
  methods: {
    ...mapActions({
      loadCurrentVehical: 'inventory/loadCurrentVehical',
      loadBrochures: 'brochure/loadBrochures',
      toggleFavorite: 'inventory/toggleFavorite'
    }),
    switchGallery () {
      console.log(this.vehicle)
      this.$f7.mainView.router.load({
        url: 'vehicale-gallery/' + this.vehicle.id
      })
      // this.$router.load({ url:  })
    },
    showMoreDesc () {
      this.isShowMore = !this.isShowMore
    },
    back () {
      let backUrl = localStorage.getItem('inventoryBackUrl')
      this.$router.load({
        url: backUrl || 'inventory'
      })
    },
    openBrochure (brochure) {
      this.isRequestActive = true
      this.$store
        .dispatch('brochure/addBrochure', brochure)
        .then(function () { })
        .catch((x) => {
          this.$f7.mainView.router.load({
            url: 'error'
          })
        })
    },
    onFavorite (data) {
      this.toggleFavorite(data)
    },
    openModal (url) {
      this.widgetLoading = true
      this.widgetUrl = url
      let iframe = document.getElementById('widget')
      iframe.onload = () => {
        if (iframe.src) { // just a trick, find better solution
          this.widgetLoading = false
        }
      }
      setTimeout(() => {
        this.widgetLoading = false
      }, 5 * 1000)
      this.$refs.modal.open()
      this.listenModalMessage()
    },
    listenModalMessage () {
      window.onmessage = (e) => {
        if (e.data === 'close') {
          this.$refs.modal.close()
          this.widgetUrl = null
        }
      }
    },
    checkAvailabilityLink () {
      let bodyText = `Hi ${this.salesPersonFullName}, can you check to see if ${this.vehicle.stockNumber} is still available.`
      openSMSEditor(this.salesPhone, bodyText)
    },
    price (price) {
      return priceHelper.toPrice(price)
    }
  },
  data () {
    return {
      isLoaded: false,
      imageViewId: 0,
      isShowMore: false,
      vehicleId: this.$route.params.id,
      isBrochureClick: false,
      widgetUrl: null,
      widgetLoading: false,
      minDescriptionLength: 200
    }
  }
}
</script>
<style scoped>
.back_image_button {
  width: 35px;
  height: 35px;
}

.car-top-image {
  position: relative;
}

.car-top-image img {
  max-height: 450px;
}

.button-yellow {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 0px;
}

.btgreen {
  background-color: #77ba82;
  color: #ffffff;
  cursor: pointer;
}

.btn-blue-outlined {
  border: 1px solid #2c61d5;
  color: #2c61d5;
}

table {
  width: 100%;
  margin-bottom: 20px;
}

td {
  padding: 10px;
  background: #f2f2f2;
  text-align: center;
  border-bottom: 1px solid #fff;
}

th {
  background-color: #f9f301;
  font-weight: bold;
  padding: 10px;
}

.button-white {
  color: #000;
  border: 1px #000 solid;
  margin-top: 15px;
}

.text-left td,
.text-left tr {
  text-align: left;
}

.brochure-list {
  padding-bottom: 10px;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.button-yellow {
  width: 30%;
  font-weight: normal;
  text-align: center;
  cursor: pointer;
  font-size: 18px;
  background-color: #f9f301;
  color: #222222;
  border: none;
  height: 45px;
}

.loader-container {
  width: 100%;
  text-align: center;
  padding-top: 15%;
}

.looping-rhombuses-spinner {
  display: inline-block;
}

.price {
  font-size: 2em;
  font-weight: 700;
}

.like-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  border: transparent;
  background: transparent;
  padding: 0;
  margin: 0;
  color: #d00000;
}

.widget-wrap {
  position: relative;
}

#widget,
.widget-wrap {
  width: 100%;
  min-height: 100%;
  box-sizing: border-box;
}

#widget {
  position: absolute;
  z-index: 0;
}

.widget-modal {
  overflow: hidden;
}

.modal-loader {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(255 255 255 / 50%);
}

.car-desc-text {
  margin-bottom: 20px;
}

.price-section {
  margin-bottom: 1rem;
}

.price-section .price-row {
  display: flex;
  column-gap: 8px;
  justify-content: space-between;
}

.price-section .price-row.summary-price {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.price-section .divider {
  border-top: #5252521A;
}

.price-section .price-row.summary-price .summary-price-value{
  color: #00267A;
}
</style>



// WEBPACK FOOTER //
// vehicle.vue?5c3ef070